import {customAxiosBE} from "../config";
import {getSessionOperator} from "../../helper/session";

function withDispatcher(payload) {
    const operator = getSessionOperator();
    return {
        ...payload,
        dispatcherUid: operator?.uid || null,
        dispatcherName: operator?.username || null,
    };
}

export async function getDispatchDeparturesAPI({from, to, lineId}) {
    const params = new URLSearchParams({from, to});
    if (lineId) params.append("lineId", lineId);
    return customAxiosBE.get(`/dispatch/departures?${params.toString()}`);
}

export async function getDispatchScheduleAPI({from, to, driverId}) {
    const params = new URLSearchParams({from, to});
    if (driverId) params.append("driverId", driverId);
    return customAxiosBE.get(`/dispatch/schedule?${params.toString()}`);
}

export async function getUnassignedDeparturesAPI({from, to, lineId}) {
    const params = new URLSearchParams({from, to});
    if (lineId) params.append("lineId", lineId);
    return customAxiosBE.get(`/dispatch/unassigned?${params.toString()}`);
}

export async function checkOrApplyAssignmentAPI(payload) {
    return customAxiosBE.post(`/dispatch/assignment`, withDispatcher(payload));
}

export async function cancelAssignmentAPI(id) {
    return customAxiosBE.delete(`/dispatch/assignment/${id}`);
}

export async function repeatAssignmentAPI(payload) {
    return customAxiosBE.post(`/dispatch/assignment/repeat`, withDispatcher(payload));
}

export async function copyWeekAPI(payload) {
    return customAxiosBE.post(`/dispatch/copy-week`, withDispatcher(payload));
}

export async function assignTurnusAPI(payload) {
    return customAxiosBE.post(`/dispatch/assignment/turnus`, withDispatcher(payload));
}

export async function getTurnusLastVehicleAPI({turnusId, day}) {
    const params = new URLSearchParams();
    if (day) {
        params.append("day", day);
    }
    const query = params.toString();
    return customAxiosBE.get(`/dispatch/turnus/${turnusId}/last-vehicle${query ? `?${query}` : ""}`);
}

export async function getTripLastVehicleAPI({tripId, tripHasVehicleId, day}) {
    const params = new URLSearchParams();
    if (tripHasVehicleId) {
        params.append("tripHasVehicleId", tripHasVehicleId);
    }
    if (day) {
        params.append("day", day);
    }
    const query = params.toString();
    return customAxiosBE.get(`/dispatch/trip/${tripId}/last-vehicle${query ? `?${query}` : ""}`);
}

export async function cancelTurnusAssignmentAPI({turnusId, journeyDate, driverId}) {
    const params = new URLSearchParams({turnusId, journeyDate, driverId});
    return customAxiosBE.delete(`/dispatch/assignment/turnus?${params.toString()}`);
}

export async function getWorkWarningsAPI({from, to}) {
    const params = new URLSearchParams({from, to});
    return customAxiosBE.get(`/dispatch/work/warnings?${params.toString()}`);
}

export async function getWorkLimitsAPI() {
    return customAxiosBE.get(`/dispatch/work/limits`);
}

export async function saveWorkLimitsAPI(payload) {
    return customAxiosBE.put(`/dispatch/work/limits`, payload);
}
